
export default function WhyChooseUs() {
  const reasons = [
    {
      icon: "ri-shield-star-line",
      title: "Atención Profesional",
      description: "Nuestro equipo está completamente certificado y capacitado para brindarle el mejor servicio. Cumplimos con todos los estándares profesionales y regulaciones."
    },
    {
      icon: "ri-global-line",
      title: "Enfoque en la Comunidad Inmigrante",
      description: "Entendemos las necesidades de la comunidad inmigrante y ofrecemos orientación clara, respetuosa y culturalmente sensible."
    },
    {
      icon: "ri-translate-2",
      title: "Servicio Bilingüe",
      description: "Ofrecemos atención en español e inglés para una comunicación clara y sin barreras."
    },
    {
      icon: "ri-time-line",
      title: "Horarios Flexibles",
      description: "Ofrecemos horarios convenientes incluyendo fines de semana y tardes. Nos adaptamos a su agenda para hacer el proceso lo más fácil posible."
    },
    {
      icon: "ri-price-tag-3-line",
      title: "Precios Transparentes",
      description: "Sin sorpresas ni cargos ocultos. Le informamos todos los costos por adelantado para que pueda tomar decisiones informadas."
    },
    {
      icon: "ri-customer-service-2-line",
      title: "Atención Personalizada",
      description: "Cada cliente recibe atención individual y dedicada. No es solo un número para nosotros, su éxito es nuestra prioridad."
    }
  ];

  const testimonials = [
    {
      name: "María González",
      location: "Silver Spring, MD",
      rating: 5,
      text: "Excelente servicio. Me ayudaron con mi ITIN y mis impuestos. El personal es muy amable y profesional. ¡Altamente recomendado!"
    },
    {
      name: "Carlos Ramírez",
      location: "Baltimore, MD",
      rating: 5,
      text: "Muy profesionales y confiables. Me guiaron en todo el proceso de la licencia de conducir. Gracias a ellos todo fue muy fácil."
    },
    {
      name: "Ana Martínez",
      location: "Rockville, MD",
      rating: 5,
      text: "El mejor servicio de impuestos que he usado. Son honestos, eficientes y siempre están disponibles para responder mis preguntas."
    }
  ];

  return (
    <section id="why-choose-us" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-2 bg-gray-100 text-gray-700 rounded-full text-sm font-medium mb-4">
            Por Qué Elegirnos
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Comprometidos con la Comunidad Hispana de Maryland
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            En VeroTax Services ofrecemos atención profesional, clara y responsable, enfocada en acompañar a nuestros clientes con respeto, transparencia y orientación personalizada.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-20">
          {reasons.map((reason, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-gray-50 to-white rounded-xl p-8 border border-gray-200 hover:border-teal-300 transition-all hover:shadow-lg"
            >
              <div className="w-14 h-14 flex items-center justify-center bg-teal-100 rounded-lg mb-6">
                <i className={`${reason.icon} text-2xl text-teal-600`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">
                {reason.title}
              </h3>
              <p className="text-gray-600 leading-relaxed text-sm">
                {reason.description}
              </p>
            </div>
          ))}
        </div>

        {/* Testimonials */}
        <div className="bg-gradient-to-br from-teal-50 to-gray-50 rounded-2xl p-8 md:p-12">
          <h3 className="text-3xl font-bold text-gray-900 mb-2 text-center">
            Lo Que Dicen Nuestros Clientes
          </h3>
          <p className="text-gray-600 text-center mb-12">Testimonios reales de clientes satisfechos</p>
          
          <div className="grid md:grid-cols-3 gap-8">
            {testimonials.map((testimonial, index) => (
              <div key={index} className="bg-white rounded-xl p-6 shadow-sm">
                <div className="flex items-center mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-yellow-400 text-lg"></i>
                  ))}
                </div>
                <p className="text-gray-700 mb-6 leading-relaxed text-sm italic">
                  "{testimonial.text}"
                </p>
                <div className="border-t pt-4">
                  <div className="font-bold text-gray-900 text-sm">{testimonial.name}</div>
                  <div className="text-xs text-gray-500">{testimonial.location}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
